// Small WebAudio beep for alerts. No external assets needed.
let ctxRef = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (ctxRef) return ctxRef;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  ctxRef = new Ctx();
  return ctxRef;
}

export function playAlertBeep() {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume();
    const t0 = ctx.currentTime;
    [880, 1175].forEach((freq, idx) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, t0 + idx * 0.18);
      g.gain.exponentialRampToValueAtTime(0.25, t0 + idx * 0.18 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + idx * 0.18 + 0.16);
      o.connect(g);
      g.connect(ctx.destination);
      o.start(t0 + idx * 0.18);
      o.stop(t0 + idx * 0.18 + 0.2);
    });
  } catch {
    /* ignore */
  }
}

export function tryNotify(title, body) {
  try {
    if (typeof window === "undefined" || !("Notification" in window)) return;
    if (Notification.permission === "granted") {
      new Notification(title, { body, silent: true });
    }
  } catch {
    /* ignore */
  }
}

export async function requestNotificationPermission() {
  try {
    if (typeof window === "undefined" || !("Notification" in window)) return "unsupported";
    if (Notification.permission === "default") {
      return await Notification.requestPermission();
    }
    return Notification.permission;
  } catch {
    return "denied";
  }
}
